import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider, Icon
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class OfferedAnswerQuestionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            showDeleteButton: this.props.showDeleteButton

        };
        this.setOptions = this.setOptions.bind(this);
    }

    componentDidMount() {

        //console.log('props opcija:' ,this.props.answerOptions);
        this.setOptions()
    }
    setOptions(){
        let options=[]
        for (let i =1 ; i<= 5; i=i+1 ){
            options.push(i)
        }
        this.setState({options})
    }



    handleChange = (e, { value }) => { //console.log('ovo saljem treba biti lista sa id: ',this.state.value, 'a profId :',this.props.staff );
    this.setState({ value },localStorage.getItem('activeRole').substr(0, 13) !== 'Administrator'?
        ()=> this.props.submitOfferedAnswerQuestion(this.props.questionId,value,this.props.staff,this.props.typeName) :()=>{}
    )
   };
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        let question={
            text: this.props.text,
            answerOptions: this.props.answerOptions,
          //  answerOptions:[],
            typeName: this.props.typeName,
            questionId: this.props.questionId
        }

        return (

            <div>

                <Header as='h4'><span style={{ color: 'red' }}>* &nbsp;</span> {question.text} {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={ {fontSize: '15px'} }>
                      <Icon name={'trash alternate'} link onClick={()=>{this.props.deleteQuestion(question.questionId)}} > </Icon>
                </span></Header>}</Header>
                <Form>
                    <Grid columns={2} centered stackable >
                        <Grid.Column width={16} stretched>

                                {  question.answerOptions.map((e)=>(
                                        <Form.Field>
                                            <Radio
                                                label={e.value}
                                                name="radioGroup"
                                                value= {e.id}
                                                checked={this.state.value === e.id}
                                                onChange={this.handleChange}
                                            />
                                        </Form.Field>

                                    )

                                )}


                        </Grid.Column>

                    </Grid>
                </Form>


                {this.props.showDivider && <Divider/>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/OfferedAnswerQuestionPreview.js